import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { split, capitalize } from 'lodash';
import { Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';

import SearchForm from '../../../../components/search-form';
import CopyButton from '../../../../components/copy-button';
import ProgressBar from '../../../../components/progress-bar';
import { getContactQueryExplainations } from '../../SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';

class QueryExplantionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      loading: false,
      error: null,
      results: null,
    };
    this.close = this.close.bind(this);
    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  close() {
    this.props.onClose();
  }
  
  loadData() {
    const { organization, settings, account, isAccount, contactType, opportunity, contact, automationId } = this.props;
    if (!this.state.loading) {
      this.setState({ loading: true, loaded: false }, () => {
        const params = {
          settings,
          ...(contactType === 'opportunity_contacts' ? {
            opportunity_id: contact.opportunity_id,
            contact_role_id: contact.contact_role_id,
          } : {}),
        };
        const objectId = isAccount ? account.account_id : opportunity.opportunity_id;
        const contactSource = contactType.replaceAll('_', '-');
        
        this.props.dispatch(getContactQueryExplainations(organization._id, isAccount, objectId, contactSource, contact.contact_id, params, automationId))
          .then(
            (results) => {
              this.setState({ error: null, results, loading: false, loaded: true });
            },
            (e) => {
              this.setState({ results: null, loading: false, loaded: false, error: e.data?.message || e.message });
            },
          );
      });
    }
  }

  renderBoolean(value) {
    return (
      <span className={`label label-default`}>{value ? 'TRUE' : 'FALSE'}</span>
    );
  }

  renderQualified(value) {
    if (value === null || value === undefined) {
      return null;
    }
    return (
      <span className={`text-uppercase label label-${value ? 'success' : 'danger'}`}>
        {value ? 'passed' : 'failed'}
      </span>
    );
  }

  renderResults() {
    const { results } = this.state;
    const { isAccount, contactType } = this.props;
    const {
      contact, opportunity, object, role,
    } = results;

    const isOpportunityContact = contactType === 'opportunity_contacts';
    
    let valid = false;
    if (results.explantions) {
      valid = results.explantions.results;
    } else {
      valid = true;
    }


    const contactAccountComp = (
      <span>
        {results.account?.name} <CopyButton style="link" size="xs" data={results.account?.account_id} tooltip="Copy ID"><Fa name="copy" /></CopyButton>
      </span>
    );

    const objectAccountComp = !isAccount && results.account?.account_id !== this.props.account.account_id ? (
      <span>
        <span className="text-warning">(Opportunity Account: {this.props.account.name}</span> <CopyButton style="link" size="xs" data={this.props.account.account_id} tooltip="Copy ID"><Fa name="copy" /></CopyButton>)
      </span>
    ) : null;

    const reports = [
      {
        label: 'Contact Source',
        results: this.getContactType(),
      },
      {
        label: isAccount ? 'Account' : 'Opportunity', // the main object
        results: object.name,
        copyText: isAccount ? object.account_id : object.opportunity_id,
      },
      ...(isAccount && isOpportunityContact ? [
        {
          label: 'Opportunity',
          results: opportunity.name,
          copyText: opportunity.opportunity_id,
        },
      ] : []),

      /*
      ...(!isAccount ? [
        {
          label: 'Opportunity Account',
          results: this.props.account.name,
          copyText: this.props.account.account_id,
        },
      ] : []),
      */
      /*
      {
        label: isAccount ? 'Account Owner' : 'Opportunity Onwer',
        results: this.props.owner.name,
        copyText: this.props.owner.user_id,
      },
      */
      {
        label: 'Contact Account',
        results: (
          <span>{contactAccountComp} {objectAccountComp}</span>
        ),
        // copyText: results.account?.account_id,
        qualified: results.external_contacts_qualified,
      },
      /*
      {
        label: 'Contact Owner',
        results: results.owner?.name,
        copyText: results.owner?.user_id,
      },
      */
      {
        label: 'Do Not Contact',
        results: this.renderBoolean(contact.do_not_contact),
        qualified: results.do_not_contact_qualified,
      },
      ...(isOpportunityContact ? [
        {
          label: 'Is Primary Contact',
          results: this.renderBoolean(role.is_primary),
          qualified: results.is_primary_qualified,
        },
        {
          label: 'Opportunity Contact Role',
          results: role.role ? role.role : (
           <em>undefined</em>
          ),
          qualified: results.contact_role_qualified,
        },
      ] : []),

      ...(this.props.contact.submitted === true || this.props.contact.submitted === false ? [
        {
          label: 'Submitted',
          results: this.renderBoolean(this.props.contact.submitted),
          qualified: !this.props.contact.submitted,
        },
      ] : []),

      {
        label: 'Trigger Conditions',
        // results: this.renderBoolean(valid),
        results: '', // empty
        qualified: valid,
      },
    ];


    const hasError = this.props.contact.remark !== undefined && this.props.contact.remark !== null;
    const hasTVError = this.props.contact.tv_error !== undefined && this.props.contact.tv_error !== null;
    console.log('');
    console.log('hasError', hasError);
    console.log('this.props.contact.remark', this.props.contact.remark);
    
    return (
      <div>
        {this.props.contact.valid &&
          <div>
            {hasTVError &&
              <div className="alert alert-warning">
                {this.props.contact.tv_error}
              </div>
            }
            {!hasTVError &&
              <div className="alert alert-success">
                This contact is qualified
              </div>
            }
          </div>
        }

        {hasError &&
          <div className="alert alert-danger">
            {JSON.stringify(this.props.contact.remark)}
          </div>
        }

        <table className="table table-condensed table-striped">
          <tbody>
            {reports.map((report) => {
              const hasCopy = report.copyText !== undefined;

              return (
                <tr key={report.label}>
                  <th width="300">{report.label}:</th>
                  <td className="text-left">
                    {report.results} {hasCopy && <CopyButton style="link" size="xs" data={report.copyText} tooltip="Copy ID"><Fa name="copy" /></CopyButton>}
                  </td>
                  <td className="text-right">
                    {this.renderQualified(report.qualified)}
                  </td>
                </tr>
              )  
            })}
          </tbody>
        </table>
        
        {results.explantions !== null && results.explantions !== undefined &&
          <SearchForm
            onSearchChange={() => {}}
            disabled
            readOnly
            standalone
            isDynamic
            simpleMode
            defaultCriteria={results.explantions}
            type="automations/test-contact-discovery-bot"
          />
        }
      </div>
    );
  }

  getContactType() {
    const { contactType } = this.props;
    if (contactType) {
      return capitalize(split(contactType, '_').join(' '));
    }
    return null;
  }

  render() {
    const { loading, loaded, error } = this.state;

    let body = null;

    if (loading) {
      body = (<div style={{ overFlow: 'hidden' }}><ProgressBar /></div>);
    } else if (!loaded) {
      body = null;
      if (error) {
        body = (
          <div className="alert alert-danger">{error}</div>
        );
      }
    } else {
      body = this.renderResults();
    }

    let title = `${this.getContactType()} trigger conditions`;
    if (this.props.contact) {
      title = `${title} for: ${this.props.contact.name}`;
    }

    return (
      <Modal bsSize="lg" show={this.props.show} onHide={this.close}>
        <Modal.Header closeButton>
          <h4>{title}</h4>
        </Modal.Header>
        <Modal.Body>
          {body}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.close} bsStyle="default">Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

QueryExplantionModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  contact: PropTypes.shape({
    contact_id: PropTypes.string.isRequired,
    opportunity_id: PropTypes.string, // for opportunty contact
    contact_role_id: PropTypes.string, // for opportunty contact
    name: PropTypes.string.isRequired,
    remark: PropTypes.string,
    tv_error: PropTypes.string,
    valid: PropTypes.bool,
    submitted: PropTypes.bool,
  }).isRequired,

  isAccount: PropTypes.bool,

  contactType: PropTypes.string.isRequired,

  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string,
    name: PropTypes.string,
  }),
  account: PropTypes.shape({
    account_id: PropTypes.string,
    name: PropTypes.string,
  }),
  owner: PropTypes.shape({
    user_id: PropTypes.string,
    name: PropTypes.string,
  }),

  show: PropTypes.bool,
  settings: PropTypes.shape({}),
  automationId: PropTypes.string,
  onClose: PropTypes.func,
  organization: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
};
QueryExplantionModal.defaultProps = {
  show: false,
  settings: {},
  opportunity: null,
  account: null,
  isAccount: false,
  owner: null,
  automationId: null,
  onClose: () => {},
};

export default connect(mapStateToProps)(QueryExplantionModal);
